"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _layout = _interopRequireDefault(require("antd/lib/layout"));

var _reactRouterDom = require("react-router-dom");

var _reselect = require("reselect");

var _Header = _interopRequireDefault(require("../components/header/Header"));

var _AdminSideBar = _interopRequireDefault(require("../components/sidebar/AdminSideBar"));

var _Admin = _interopRequireDefault(require("../pages/admin/home/Admin"));

var _AdminSettingsPage = _interopRequireDefault(require("../pages/admin/settings/AdminSettingsPage"));

var _AdminStudiesPage = _interopRequireDefault(require("../pages/admin/studies/AdminStudiesPage"));

var _AdminUsersPage = _interopRequireDefault(require("../pages/admin/users/AdminUsersPage"));

var _CmsPage = _interopRequireDefault(require("../pages/cms/home/CmsPage"));

var _CmsEditPage = _interopRequireDefault(require("../pages/cms/home/CmsEditPage"));

var selectors = _interopRequireWildcard(require("../redux/selectors"));

var _study = require("../redux/study/study.types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Content,
  Footer
} = _layout.default;

class AdminRouter extends _react.default.Component {
  componentDidMount() {
    const {
      loadStudies,
      studies
    } = this.props;

    if (!studies) {
      loadStudies();
    }
  }

  render() {
    const {
      studies,
      studiesLoadingStatus
    } = this.props;

    if (studiesLoadingStatus.isLoading) {
      return /*#__PURE__*/_react.default.createElement("div", null, "Loading...");
    }

    if (studiesLoadingStatus.isError) {
      return /*#__PURE__*/_react.default.createElement("div", null, "Error");
    }

    if (!studies) {
      return /*#__PURE__*/_react.default.createElement("div", null, "The studies could not be loaded");
    }

    return /*#__PURE__*/_react.default.createElement(_layout.default, {
      style: {
        minHeight: '100vh'
      }
    }, /*#__PURE__*/_react.default.createElement(_AdminSideBar.default, null), /*#__PURE__*/_react.default.createElement(_layout.default, {
      id: "main"
    }, /*#__PURE__*/_react.default.createElement(_Header.default, null), /*#__PURE__*/_react.default.createElement(Content, {
      id: "content"
    }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      exact: true,
      path: "/admin/home",
      component: _Admin.default
    }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      exact: true,
      path: "/admin/users",
      component: _AdminUsersPage.default
    }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      exact: true,
      path: "/admin/studies",
      component: _AdminStudiesPage.default
    }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      exact: true,
      path: "/admin/settings",
      component: _AdminSettingsPage.default
    }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      exact: true,
      path: "/admin/cms",
      component: _CmsPage.default
    }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      exact: true,
      path: "/admin/cms/article/new",
      component: _CmsEditPage.default
    }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      path: "/admin",
      component: _Admin.default
    }))), /*#__PURE__*/_react.default.createElement(Footer, null, "Footer")));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  studies: selectors.getStudies,
  studiesLoadingStatus: selectors.loadStudiesStatus
});

const mapDispatchToProps = dispatch => {
  return {
    loadStudies: () => dispatch(_study.loadStudiesAsync.request())
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AdminRouter);

exports.default = _default;